export default "__VITE_ASSET__DM9lS3S2__"